import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import redo from '@/images/Redo.svg';
import undo from '@/images/Undo.svg';
import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import { useAdvancedEditorContext } from '../../context/useAdvancedEditorContext';
import { AutoSaveStatus } from './AutoSaveStatus';

const StyledMaskedIcon = styled(MaskedIcon)<{ isDisabled?: boolean }>`
    color: ${({ theme, isDisabled }) => (isDisabled ? theme.colors.black[500] : theme.colors.black[700])};
`;
const StyledIconButton = styled(IconButton)`
    padding: 4px;
    border-radius: 12px;
    &:hover {
        background-color: ${({ theme }) => theme.colors.black[100]};
    }
`;

const CanvasHeaderWrapper = styled.div`
    position: absolute;
    z-index: 1;
    top: 15px;
    right: 240px;
`;

export const CanvasHeader = () => {
    const { store } = useAdvancedEditorContext();

    const handleUndo = () => {
        store.history.undo();
    };

    const handleRedo = () => {
        store.history.redo();
    };

    const { canUndo, canRedo } = store.history;

    return (
        <CanvasHeaderWrapper>
            <AutoSaveStatus />
            <StyledIconButton onClick={handleUndo} disabled={!canUndo}>
                <StyledMaskedIcon src={undo} size="32px" isDisabled={!canUndo} />
            </StyledIconButton>

            <StyledIconButton onClick={handleRedo} disabled={!canRedo}>
                <StyledMaskedIcon src={redo} size="32px" isDisabled={!canRedo} />
            </StyledIconButton>
        </CanvasHeaderWrapper>
    );
};
